<template>
    <div>
        <!-- TODO: A VIRER -->
    </div>
</template>

<script>

    import {mapState, mapActions, mapGetters} from 'vuex';

    import store from '../store';
    import CartWidgetItem from './CartWidgetItem.vue';

    const CartWidget = {
        name: 'ponroy-cart-widget',
        store,
    };

    export default CartWidget;
</script>



// WEBPACK FOOTER //
// src/SiteBundle/Resources/assets/components/CartWidget.vue